class VariantSelectionStrategy {
  selectVariant(product, context) {
    throw new Error('Method selectVariant() must be implemented');
  }
}

class BundleColorVariantStrategy extends VariantSelectionStrategy {
  selectVariant(product, context) {
    const { productsColorBundle, colorSelected } = context;
    if (productsColorBundle?.length > 0 && !colorSelected) {
      const productColor = productsColorBundle.find(
        (x) => x.product_title === product.title
      )?.color;

      if (productColor && product.variants.length > 1) {
        const colorVariant = product.variants.find((variant) =>
          variant.title.includes(productColor)
        );
        return colorVariant?.id ?? product.variants[0].id;
      }
    }
    return null;
  }
}

class RegularVariantStrategy extends VariantSelectionStrategy {
  selectVariant(product, context) {
    const { colorSelected } = context;
    if (product.variants.length > 1) {
      const colorVariant = product.variants.find((variant) =>
        variant.title.includes(colorSelected)
      );
      return colorVariant?.id ?? product.variants[0].id;
    }
    return product.variants[0].id;
  }
}

class VariantSelectionContext {
  constructor() {
    this.strategies = [
      new BundleColorVariantStrategy(),
      new RegularVariantStrategy()
    ];
  }

  selectVariant(product, context) {
    for (const strategy of this.strategies) {
      const variantId = strategy.selectVariant(product, context);
      if (variantId) {
        return variantId;
      }
    }
    return product.variants[0].id;
  }
}

export {
  VariantSelectionStrategy,
  BundleColorVariantStrategy,
  RegularVariantStrategy,
  VariantSelectionContext
};
